if (!customElements.get('module-four')) {
  class ModuleFour extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.wrappers = this.querySelectorAll('.package-product--wrapper');
      this.buttons = this.querySelectorAll('.package-product-btn');

      this.buttons.forEach(btn => {
        btn.addEventListener('click', event => {
          this.btnClick(event);
        })
      })

      this.packageSectionSlider();
      this.thumbnailClick();
    }
    btnClick(event) {
      event.preventDefault();
      const nextIndex = event.currentTarget.getAttribute('data-next-index');
      this.querySelector('.package-product--wrapper.active')?.classList.remove('active');
      this.wrappers.forEach(wrapper => {
        if (wrapper.getAttribute('data-wrapper-index') == nextIndex) {
          wrapper.classList.add('active');
        }
      })
    }
    packageSectionSlider() {
      this.packageSections = this.querySelectorAll('.package-product--images');
      this.packageSections.forEach((packageSection, index) => {
        const packageSectionImagesWrapper = packageSection.querySelector('.package-product--images-container');
        const packageSectionImages = packageSection.querySelectorAll('.package-product--image');

        if (packageSectionImagesWrapper && packageSectionImages && packageSectionImages.length > 1) {
          const flickityOptions = {
            contain: true,
            pageDots: false
          };
          const flickityInstance = new Flickity(packageSectionImagesWrapper, flickityOptions);

          if (index === 0) {
            this.packageSectionOne = packageSection;
            this.sectionFlickyOne = flickityInstance;
          } else {
            this.packageSectionTwo = packageSection;
            this.sectionFlickyTwo = flickityInstance;
          }
        }
      })
    }
    thumbnailClick() {
      this.thumbnails = this.querySelectorAll('.package-product--thumbnail');
      this.thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', event => {
          event.preventDefault();
          const currentSectionIndex = event.currentTarget.getAttribute('data-section-index');
          const currentProductId = event.currentTarget.getAttribute('data-product-id');
          let targetSection = this.packageSectionOne;
          let targetFlicky = this.sectionFlickyOne;
          if (currentSectionIndex == 2) {
            targetSection = this.packageSectionTwo;
            targetFlicky = this.sectionFlickyTwo;
          }
          const targetImages = targetSection.querySelectorAll('.package-product--image');
          targetImages.forEach((tImg, index) => {
            if (tImg.getAttribute('data-product-id') == currentProductId) {
              targetFlicky.select(index);
            }
          })
        })
      })
    }
  }
  customElements.define('module-four', ModuleFour);
}